// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-iframe-wrap .next-btn-position[data-v-6b3a2c68]{right:3%}", ""]);
// Exports
module.exports = exports;
